import * as React from "react"
import { TextFieldSeeker } from "@ui-seeker/core"

import { useAdminBrandForm } from "../../@hooks"


export default function AdminBrandsKeywordTextField({ disabled }) {
	const { value, handleChange } = useAdminBrandForm('keyword')

    return <TextFieldSeeker
		label="Keyword"
		placeholder="Please enter keywords..."
		value={value}
		disabled={disabled}
		onChange={e => handleChange(e.target.value)}
	/>
}
